import React from "react";
import { ProgressBar } from "react-bootstrap";

export default function ComingSoon() {
  return (
    <div>
      <ProgressBar now={60} className="mb-3 "variant="colored" />;
      <span className="fw-bold my-3">This feature is coming soon...</span>
    </div>
  );
}
